import { Blocks, ShoppingBag, ShoppingCart } from "lucide-react";
import React from "react";

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function FooterCard4() {
  return (<>
    <footer className="eye-footer">

      {/* Main Footer Grid */}
      <div className="eye-grid">

        {/* Column 1 — Brand */}
        <div className="eye-col">
            <div className="eye-circle" ><ShoppingCart size={35} color={"#ffffff"} /></div>
                 <h1>TestPrism</h1>  

          <p>
            Smart practice platform for  aspirants.
            
          </p>

        </div>

        {/* Column 2 — Useful Links */}
        

        {/* Column 3 — Glasses For */}
        <div className="eye-col">
          <h3>Our Features</h3>
          <a href="javascript:void(0)">Free & Premium Mock Tests
</a>
          <a href="javascript:void(0)">
       Telegram Support
</a>


        </div>

        {/* Column 4 — Contact */}
        <div className="eye-col">
          <h3>CONTACT US</h3>

          <p>testprism@gmail.com</p>

          {/* Social boxes without real icons */}
          <div className="social-boxes">
            <div className="social"> <FaFacebookF />
                        </div>
            <div className="social"><FaTwitter />
                        </div>
            <div className="social"><FaInstagram />
                        </div>
            <div className="social"><FaLinkedinIn />
                      </div>
          </div>
        </div>
      </div>

      {/* Bottom SEO Text Row */}
      <div className="eye-seo-tags">
      <div> SSC CGL</div> <div>|</div><div>NABARD</div><div>|</div> <div>SEBI</div><div>|</div> <div>UPSC</div> <div>|</div><div>RAILWAYS</div> <div></div> 
         
      </div>

          <p className="copy">Copyright © 2026 craftloon</p>
       
    </footer>
    <style>{`.eye-footer { margin-top:50px;
  background: #efefef;
  padding: 60px 8%;
  font-family: "Inter", sans-serif;
  color: #000;
}

/* Grid */
.eye-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 50px;
  margin-bottom: 40px;
}
.eye-circle {
  width: 70px;display:flex;justify-content:center;align-items:center;
  height: 70px;
  border-radius: 50%;
  background: rgba(144, 202, 249,1);
  margin-bottom: 10px;
}
/* Logo */
.eye-logo {
  width: 160px;
  margin-bottom: 20px;
}

/* Column Titles */
.eye-col h3 {
  font-size: 18px;border-bottom:2px dashed #444444; padding-bottom:5px;
  font-weight: 700;
  margin-bottom: 15px;
}

/* Text + Links */
.eye-col p,
.eye-col a {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 12px;
  display: block;
  color: #333;
  text-decoration: none;
}

/* Copyright */
.copy {
  margin-top: 20px;
  font-weight: 600;
}
.theme-name {
  margin-top: 4px;
  font-size: 14px;
  color: #333;
}

.eye-btn {
  margin-top: 10px;
  padding: 10px 20px;
  background: #000;
  color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

/* App Download */
.download-title {
  margin-top: 30px;
  margin-bottom: 15px;
}

.app-row {
  display: flex;
  gap: 10px;
}

.app-box {
  background: #000;
  color: #fff;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

/* Social Boxes (no icons) */
.social-boxes {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.social {
  width: 35px;
  height: 35px;
  background: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
}

/* SEO bottom tags */
.eye-seo-tags {
  padding-top: 20px;display:flex;gap:10px;justify-content:left;
  border-top: 1px solid #ccc;
  font-size: 13px;
  color: #444;
}
`}</style>
    </>
  );
}
